<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Search -->
          <div class="search-section">
            <div class="row align-items-center">
              <div class="col-lg-5">
                <div class="row align-items-center mx-0">
                  <div class="col-md-6">
                    <div class="form-wrap icon-form mb-0 info-container">
                      <span class="form-icon"><i class="ti ti-search"></i></span>
                      <!-- <input type="text" class="form-control" placeholder="Search opportunities"
                        v-model="searchOppBoardQuery" /> -->
                      <input type="text" class="form-control" placeholder="Search opportunities"
                        v-model="searchOppBoardQuery" @input="debouncedSearchOpportunities()" 
                      />
                      <i class="ti ti-info-circle info-icon" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Search Opportunity number, Description, Comment, Organisation Name"></i>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <user-filters :from="'opportunity'" @filterData="searchOpportunitiesBoard"></user-filters>
                  </div>
                </div>
              </div>
              <div class="col-lg-7 mt-3 mt-lg-0">
                <div class="export-list text-sm-end">
                  <ul>
                    <li class="mb-3 mb-md-4">
                      <div class="form-wrap text-start mb-0">
                        <label class="col-form-label filter-lable">Opp Type </label>
                        <Field as="select" name="opp_type" class="form-select py-2" v-model="filters.opp_type"
                          @change="oppTypeFilter">
                          <option value="">All</option>
                          <option v-for="res in options.opp_type" :key="res.value" :value="res.value">
                            {{ res.text }}
                          </option>
                        </Field>
                      </div>
                    </li>
                    <li class="">
                      <div class="form-wrap mb-0">
                        <label class="col-form-label filter-lable w-100 text-start">CED Range</label>
                        <select class="form-select py-2" v-model="isActive" @change="toggleFilter">
                          <option value="All">All</option>
                          <option value="within_365_or_blank">Blank or LT 365</option>
                          <option value="greater_than_365">Greater than 365</option>
                        </select>
                      </div>
                    </li>

                    <li class="">
                      <div class="form-wrap mb-0">
                        <label class="col-form-label filter-lable w-100 text-start">Next Update Latest</label>
                        <select class="form-select py-2" v-model="nextUpdateFilter" @change="applyNextUpdateFilter">
                          <option value="all">All</option>
                          <option value="current">Current</option>
                          <option value="future">Future</option>
                        </select>
                      </div>
                    </li>

                    <li class="mb-0 me-0 me-xl-2">
                      <div class="view-icons me-0 me-md-2">
                        <router-link to="/crm/meter-opportunities-kanban" class="active"><i
                            class="ti ti-layout-kanban"></i></router-link>
                        <router-link to="/crm/meter-opportunities-list"><i class="ti ti-list-tree"></i></router-link>
                      </div>
                    </li>
                    <li class="mb-0 d-flex gap-2">
                      <div class="form-sorts dropdown">
                        <a href="javascript:void(0);" data-bs-toggle="dropdown" data-bs-auto-close="outside">
                          <i class="ti ti-filter-share"></i>Filter
                        </a>
                        <div class="filter-dropdown-menu dropdown-menu dropdown-menu-xl-end">
                          <div class="filter-set-view">
                            <div class="filter-set-head">
                              <h4><i class="ti ti-filter-share"></i>Filter</h4>
                            </div>
                            <div class="filter-content-list mb-2">
                              <label for="search-status" class="mb-2">Next update Start Date - Next update End
                                Date</label>
                              <date-time-picker v-model="date" :enable-time-picker="false" range multi-calendars
                                format="yyyy-MM-dd" />
                              <!-- <date-time-picker v-model="date" :range="true" :multiple="true" format="yyyy-MM-dd" /> -->
                            </div>
                            <div class="filter-reset-btns">
                              <div class="row">
                                <div class="col-6">
                                  <a href="javascript:void(0);" class="btn btn-light" @click="resetFilters">Reset</a>
                                </div>
                                <div class="col-6">
                                  <a href="javascript:void(0);" class="btn btn-primary" @click="applyFilters">Filter</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <router-link :to="{ path: '/crm/create-meter-opportunity', query: { kanban: true } }"
                        class="btn btn-primary" title="Add Opportunity"><i
                          class="ti ti-square-rounded-plus"></i>Add</router-link>
                    </li>
                    <!-- <li class="mb-0">
                      
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- /Search -->

          <!-- Leads Kanban -->
          <meter-opportunities-board :search-board-query="searchOppBoardQuery" :filterData="filters" :filters="date"
            :date_range="isActive" :next_update="nextUpdateFilter" ref="oppBoardTable"></meter-opportunities-board>

          <!-- /Leads Kanban -->
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <opportunities-list-modal></opportunities-list-modal>
</template>

<script>
import {
  ref, computed, onMounted, onBeforeUnmount, watch
} from 'vue';
import { useStore } from "vuex";
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      title: "Meter Opportunities",
    };
  },
  setup() {
    const store = useStore();
    const searchOppBoardQuery = ref(""); // Example: For holding search query input
    const oppBoardTable = ref(null);
    const date = ref(null);
    const isActive = ref(localStorage.getItem('opp365') || "All");
    const nextUpdateFilter = ref(localStorage.getItem('next_update_latest') || "current");
    const filters = ref({
      opp_type: localStorage.getItem('oppType') || ""
    })

    const options = computed(
      () => store.getters["opportunity/getoppDropdowns"]
    );
    const oppTypeFilter = () => {
      localStorage.setItem('oppType', filters.value.opp_type);
      setTimeout(() => {
        applyFilters();
      }, 0);
    }

    const searchOpportunitiesBoard = () => {
      if (oppBoardTable.value) {
        oppBoardTable.value.fetchBoardOpportunities();
      }
    };

    // Debounce timer
    const debounceTimeout = ref(null);

    // Debounced wrapper for search
    const debouncedSearchOpportunities = () => {
      clearTimeout(debounceTimeout.value);
      debounceTimeout.value = setTimeout(() => {
        searchOpportunitiesBoard();
      }, 1000); // triggers only after user stops typing for 500ms
    };

    const resetFilters = () => {
      date.value = null;
      setTimeout(() => {
        applyFilters();
      }, 0);
    };
    const toggleFilter = () => {
      localStorage.setItem('opp365', isActive.value);
      setTimeout(() => {
        applyFilters();
      }, 0);
    };
    const applyFilters = () => {
      searchOpportunitiesBoard();
    };

    const applyNextUpdateFilter = () => {
      localStorage.setItem('next_update_latest', nextUpdateFilter.value);
      setTimeout(() => {
        applyFilters();
      }, 0);
    };

    // Watch search input
    watch(searchOppBoardQuery, (newQuery) => {
      debouncedSearchOpportunities();
    });

    onMounted(async () => {
      store.dispatch('opportunity/fetchOpportunityOptions');
      const isVertical = store.getters["changelayout/getHeader"];
      if (isVertical) {
        store.dispatch("changelayout/toggleHeader", "meterOpp");
      }
    });

    onBeforeUnmount(() => {
      clearTimeout(debounceTimeout.value); // cleanup
    });

    return {
      searchOppBoardQuery,
      date,
      oppBoardTable,
      resetFilters,
      searchOpportunitiesBoard,
      debouncedSearchOpportunities, // exposed for input
      applyFilters,
      toggleFilter,
      filters,
      options,
      oppTypeFilter,
      isActive,
      nextUpdateFilter,
      applyNextUpdateFilter
    }
  }
};
</script>
